import React from 'react';
import { maxWidthContainerWithoutGutters } from '@noths/polaris-client-ribbons-base';
import {
  PartnerPageHeader,
  PressComment,
  TextAndImage,
} from '@noths/polaris-client-ribbons-design-system';

import { PartnerLegals } from 'src/components/molecules/PartnerLegals/PartnerLegals';
import { Tabs } from 'src/components/molecules/Tabs/Tabs';
import type {
  ContentstackPartner,
  ImageConnection,
} from 'src/services/contentstack/types/PartnerPage.types';
import * as styles from './PartnerStorefrontLayout.styles';

const getImages = (imageConnection: ImageConnection) => {
  return imageConnection.edges
    .filter((edge) => {
      return !!edge;
    })
    .map((edge) => ({
      alt: edge.node.description,
      src: edge.node.url,
    }));
};

interface PartnerStorefrontLayoutProps {
  partner: ContentstackPartner;
}

export const PartnerStorefrontLayout = ({ partner }: PartnerStorefrontLayoutProps) => {
  return (
    <>
      <div css={styles.partnerPageHeaderWrapper}>
        <div css={maxWidthContainerWithoutGutters}>
          <PartnerPageHeader
            coverImageSrc={partner.cover_imageConnection.edges[0]?.node.url || ''}
            introText={partner.short_brand_bio ?? ''}
            location={partner.location ?? ''}
            logoImageSrc={partner.logoConnection.edges[0]?.node.url || ''}
            name={partner.name}
            startDate={partner.partner_start_date ?? ''}
          />
        </div>
      </div>
      <div css={styles.container}>
        <Tabs
          ariaLabel="Partner products and content navigation"
          tabs={[
            {
              href: `/partners/${partner.shortcode}/products`,
              label: 'Our products',
            },
            {
              active: true,
              href: `/partners/${partner.shortcode}`,
              label: 'Our story',
            },
          ]}
        />
        <br />
        <TextAndImage
          body={partner.story_text || ''}
          heading="About"
          images={getImages(partner.story_imagesConnection ?? { edges: [] })}
          subHeading={partner.story_summary || ''}
          textColumn="left"
        />
        {partner.more_about_you && (
          <TextAndImage
            body={partner.more_about_you.text || ''}
            heading={partner.more_about_you.summary || ''}
            images={getImages(partner.more_about_you.imageConnection)}
            textColumn="right"
          />
        )}
        {partner.press_comments?.length ? (
          <section css={styles.pressCommentsSection}>
            <h2>Press comments</h2>
            <ul>
              {partner.press_comments.map((comment) => (
                <li key={`${comment.author}-${comment.date}`}>
                  <PressComment
                    comment={comment.text}
                    date={comment.date}
                    href={comment.link}
                    source={comment.author}
                  />
                </li>
              ))}
            </ul>
          </section>
        ) : null}
        <PartnerLegals
          returnAddress={partner.returns_address ?? ''}
          vatNumber={partner.vat_number ?? ''}
        />
      </div>
    </>
  );
};
